/** Shown in the browser tab after each route title, e.g. `Dashboard | SBE Admin`. */
export const APP_BROWSER_TITLE = 'SBE Admin';
